import React from "react";

const TradingViewMiniChart = ({ symbol, width = 250, height = 150 }) => {
  React.useEffect(() => {
    const id = `tradingview_${symbol.replace(/[:.]/g, "_")}`;
    const root = document.getElementById(id);
    if (!root) return;
    // Clear previous instance to avoid duplicates
    root.innerHTML = "";

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbol,
      width: String(width),
      height: String(height),
      locale: "en",
      dateRange: "3M",
      colorTheme: "light",
      isTransparent: false,
      autosize: false,
    });
    root.appendChild(script);

    return () => {
      try { root.innerHTML = ""; } catch { /* ignore */ }
    };
  }, [symbol, width, height]);

  return (
    <div className="tradingview-widget-container">
      <div id={`tradingview_${symbol.replace(/[:.]/g, "_")}`}></div>
    </div>
  );
};

export default TradingViewMiniChart;
